import { useState, useRef, useEffect } from 'react'
import TermSwitcher from './TermSwitcher'
import ThemeToggle from './ThemeToggle'
import nudgLogo from '@/assets/branding/nudg-u-logo.png'

function Header({ currentPage, onNavigate, terms, activeTermId, onSwitchTerm, onSignOut }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef(null)

  const navItems = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'schedule', label: 'Class Schedule' },
    { id: 'daily-schedules', label: 'Daily Plans' },
    { id: 'tasks', label: 'Tasks' },
    { id: 'medication', label: 'Medication' },
    { id: 'terms', label: 'Terms' },
    { id: 'settings', label: 'Settings' },
  ]

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuOpen])

  return (
    <div className="header-wrapper">
      <header className="app-header" ref={menuRef}>
        <div className="header-brand">
          <button
            className="header-home-btn"
            onClick={() => onNavigate('dashboard')}
            title="Go to Dashboard"
            aria-label="Home"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </button>
          <img className="header-logo" src={nudgLogo} alt="" />
          <h1
            className="header-title"
            onClick={() => {
              const container = document.querySelector('.pull-to-refresh-container')
              if (container) container.scrollTo({ top: 0, behavior: 'smooth' })
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }}
          >
            Nudg.U
          </h1>
        </div>
        <div className="header-center">
          {terms && terms.length > 0 && (
            <TermSwitcher terms={terms} activeTermId={activeTermId} onSwitchTerm={onSwitchTerm} />
          )}
          <ThemeToggle />
        </div>
        <nav className="desktop-nav">
          {navItems.map(({ id, label }) => (
            <button
              key={id}
              className={`desktop-nav-item${currentPage === id ? ' desktop-nav-item--active' : ''}`}
              onClick={() => onNavigate(id)}
            >
              {label}
            </button>
          ))}
          {onSignOut && (
            <button
              className="desktop-nav-item desktop-nav-item--signout"
              onClick={onSignOut}
            >
              Sign Out
            </button>
          )}
        </nav>
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Navigation menu"
          aria-expanded={menuOpen}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        {menuOpen && (
          <nav className="hamburger-dropdown">
            {navItems.map(({ id, label }) => (
              <button
                key={id}
                className={`hamburger-dropdown-item${currentPage === id ? ' hamburger-dropdown-item--active' : ''}`}
                onClick={() => { onNavigate(id); setMenuOpen(false) }}
              >
                {label}
              </button>
            ))}
            {onSignOut && (
              <button
                className="hamburger-dropdown-item hamburger-dropdown-item--signout"
                onClick={() => { onSignOut(); setMenuOpen(false) }}
              >
                Sign Out
              </button>
            )}
          </nav>
        )}
      </header>
    </div>
  )
}

export default Header
